import store from '@shared/store'
import { languagesList } from '@/i18n/languages'

const availableLanguages = languagesList.map(language => language.code)

const applicationLanguage = () => {
    const serializedLanguages = (window.settings && typeof window.settings.languages === 'function')
        ? window.settings.languages() : JSON.stringify(availableLanguages)

    const selectedLanguage = availableLanguages.includes(store.state.locale) ? store.state.locale : undefined
    const preferredLanguages = JSON.parse(serializedLanguages).map(locale => locale.substring(0, 2))
    const languages = preferredLanguages.filter(x => availableLanguages.includes(x))
    return selectedLanguage || languages[0] || availableLanguages[0]
}

export default applicationLanguage
